require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wod-2017-11-15.json") })
        }
      }, "path---wod-2017-11-15");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---wod-2017-11-15!./.cache/json/wod-2017-11-15.json
// module id = 464
// module chunks = 231608221292675